<template>
  <div class="content">
      <span>
          {{msg}}
      </span>
  </div>
</template>
<script>
    export default{
        data(){
            return{
          msg:"hello"
            }
        }
    }
</script>
<style scoped>
 
</style>



// WEBPACK FOOTER //
// src/components/details/details.vue